import React from 'react';
import PropTypes from 'prop-types';
import MuiRadio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FormControlLabel } from './style';

const Radio = ({ label, color, labelPlacement, checked, onChange, value, disabled, ...props }) => {

  if (!label) {
    return (
      <MuiRadio
        disabled={disabled}
        onChange={onChange}
        checked={checked}
        color={color}
        value={value}
        {...props}
      />
    );
  }

  return (
    <FormControlLabel
      labelPlacement={labelPlacement}
      disabled={disabled}
      value={value}
      control={
        <MuiRadio onChange={onChange} checked={checked} color={color} value={value} {...props} />
      }
      label={label}
    />
  );
};

Radio.propTypes = {
  label: PropTypes.string,
  labelPlacement: PropTypes.string,
  color: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

Radio.defaultProps = {
  label: undefined,
  labelPlacement: 'end',
  color: 'primary',
  checked: undefined,
  value: undefined,
  disabled: false,
  onChange: () => {},
};

Radio.RadioGroup = RadioGroup;

export default Radio;
